import { render, staticRenderFns } from "./CardTarjaEnqueteSaiaJustaQRCODE.vue?vue&type=template&id=2ed440b4&scoped=true"
import script from "./CardTarjaEnqueteSaiaJustaQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSaiaJustaQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSaiaJustaQRCODE.vue?vue&type=style&index=0&id=2ed440b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed440b4",
  null
  
)

export default component.exports